import {TreeNode} from 'primeng/api';


export class  CompiledRecord {
    id!: number;
    patientName!: string;
    patientId!: string;
    medDesc!: string;
    medId!: string;
    loc!: string;
    adminId!: string;
    serviceGroup!: string;
    var!: string;
    uom!: string;
    admin!: Date;
    transType!: string;
    resolutionCoding!: string;
    entityType: string | null = null;
    children!:any[];
    maapKey!:string;
    mrnNum!:string;
    comment!:string;
    resolution!:string;
    lanId!:string;
    employeeName!: string;
    userGrp!:string;
    adminGroup!:string;
    uniqueKey2!:string;
    discDesc!:string;
    region!:string;
    campus!:string;
    facility!:string;
    regionId!:string;
    campusId!:string;
    facilityId!:string;
    varDateString!:string

    static fromJSON(object: any)
    {

      const variance = new CompiledRecord();
        variance.children = [];
        variance.id=object._id;
        variance.employeeName=object.employeeName;
        variance.mrnNum = object.mrnNum.replace("Error","NoEHR");
        variance.patientName=object.patientName;;
        variance.patientId=object.patientName;
        variance.medDesc=object.medDesc;
        variance.medId=object.medID;
        variance.loc=object.bedDev;
        variance.adminId=object.employeeName;
        variance.var=object.amount;
        variance.uom=object.uom;
        variance.admin=new Date(object.varDate);
        variance.varDateString =object.varDateString
        variance.transType=object.transType;
        variance.resolutionCoding=object.resolution;
        variance.lanId=object.lanID;
        variance.userGrp = object.userGroup;
        variance.serviceGroup = object.serviceGroup;
        variance.adminGroup = object.adminGroup;
        variance.uniqueKey2 = object.uniqueKey2;
        variance.region = object.region;
        variance.campus = object.campus;
        variance.facility = object.facility;
        variance.regionId = object.regionId;
        variance.campusId = object.campusId;
        variance.facilityId = object.facilityId;
        return variance;
    }




    static toTreeNode(record:CompiledRecord):TreeNode
    {
        return ({data:Object.assign({}, record), children:[{data:{label:"Compiled Data"},children:[{}]},{data:{label:"ADC Data"},children:[{}]},{data:{label:"EHR Data"},children:[{}]}], leaf:true, expanded:false, parent:null} as unknown) as TreeNode
    }

  }
